/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
  $('.modal-body').spinner().start();

  if ($('#chooseBonusProductModal').length !== 0) {
    $('#chooseBonusProductModal').remove();
  }
  var bonusUrl;
  if (data.bonusChoiceRuleBased) {
    bonusUrl = data.showProductsUrlRuleBased;
  } else {
    bonusUrl = data.showProductsUrlListBased;
  }

  var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" role="dialog">'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span>' + data.labels.close + '</span>&times;'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
  $('body').append(htmlString);
  $('.modal-body').spinner().start();

  $.ajax({
    url: bonusUrl,
    method: 'GET',
    dataType: 'html',
    success: function (html) {
      var parsedHtml = parseHtml(html);
      $('#chooseBonusProductModal .modal-body').empty();
      $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
      $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
      $('#chooseBonusProductModal').modal('show');
      $.spinner().stop();
    },
    error: function () {
      $.spinner().stop();
    }
  });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
class addToCartMsg {
  handlePostCartAdd(response) {
    const minicart = $('.mini-cart');
    const breakpoint = Foundation.MediaQuery.current;

    minicart.trigger('count:update', response);

    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
      chooseBonusProducts(response.newBonusDiscountLineItem);
    } else if (breakpoint === 'large' || breakpoint === 'xlarge' || breakpoint === 'xxlarge') {
      minicart.addClass('popup-open');
      $('.mini-cart-link').trigger('mouseenter');

      $('.mini-cart-link').on('mouseenter', () => {
        clearTimeout(triggerMinicart);
      });

      let triggerMinicart = setTimeout(() => {
        minicart.removeClass('popup-open');
      }, 3500);
    } else if (breakpoint === 'small') {
      var modal = $('#added-to-cart-modal')
      initAddedToCartConfirmationModal(modal, response);

      var addedToCartModal = new Foundation.Reveal(modal);
      addedToCartModal.open();
    }
  }
}

function initAddedToCartConfirmationModal(modal, data) {
  const messageType = data.error ? 'alert' : 'success';
  modal.find('header').removeClass('alert success');
  modal.find('header h4').html('');
  modal.find('.modal-content .product-preview').html('');

  modal.find('header').addClass(`${messageType}`);
  modal.find('header h4').html(`${data.message}`);
  modal.find('.modal-content .product-preview').html(`${data.cartLastItemSnippet}`);

  modal.on('open.zf.reveal', function (event) {
    document.dispatchEvent(new Event('product:afterConfirmationModalOpen'));
  })

  modal.on('closed.zf.reveal', function (event) {
    document.dispatchEvent(new Event('product:afterConfirmationModalClose'));
  })

}

const AddToCartMsg = new addToCartMsg();
export default AddToCartMsg;



// WEBPACK FOOTER //
// ./assets/scripts/product/addToCartMsg.js